<template>
  <div class="bj-section">
    <div class="link-warp">
      <div
        :class="['link-item', { active: item.id === state }]"
        v-for="item in navList"
        :key="item.value"
        @click="onNavClick(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <template v-if="state === 0 && DNSResult">
      <div style="margin-top: 40px;">
        <div class="item-row">
          <div class="name">域名:</div>
          <div class="label">{{ name }}</div>
        </div>
        <div class="item-row">
          <div class="name">DNS类型:</div>
          <div class="label">
            <RadioGroup v-model="form.dnsType">
              <Radio class="bj-color-F85A36" :label="0">出售页DNS</Radio>
              <Radio class="bj-color-F85A36" :label="2">解析DNS</Radio>
              <Radio class="bj-color-F85A36" :label="1">第三方DNS</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="item-row" style="align-items: self-start;">
          <div class="name" :style="{ paddingTop: form.dnsType === 1 ? '10px' : '0' }">DNS记录值:</div>
          <div class="label" style="flex: 0 0 628px">
            <template v-if="form.dnsType === 0">
              <div class="item-row" style="margin-bottom: 0">
                <div class="name" v-for="(item, index) in dnsList0" :key="'p' + index">
                  <span style="color: #fff">DNS{{ index + 1 }}：</span>
                  {{ item }}
                </div>
              </div>
            </template>
            <template v-if="form.dnsType === 2">
              <div class="item-row">
                <div class="name" v-for="(item, index) in dnsList1" :key="'p' + index">
                  <span style="color: #fff">DNS{{ index + 1 }}：</span>
                  {{ item }}
                </div>
              </div>
            </template>
            <template v-if="form.dnsType === 1">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;
                  padding-top: 10px;
                "
              >
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: self-start;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                  "
                >
                  <div
                    v-for="(item, index) in dnsInputList"
                    :key="'i' + index"
                    class="flx-row-s-c"
                    style="
                      margin-bottom: 10px;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: flex-start;
                    "
                  >
                    <div class="f-14 c-g">DNS{{ index + 1 }}：</div>
                    <Input
                      class="bj-input-26262A bj-input-h45"
                      v-model.trim="dnsInputList[index]"
                      placeholder="请填写"
                      style="width: 200px; margin-right: 10px"
                    />
                  </div>
                </div>
                <div style="flex: 0 0 105px; display: flex">
                  <div
                    v-show="dnsInputList.length > 1"
                    class="btn-add"
                    @click="cutEvent"
                  >
                    -
                  </div>
                  <div
                    v-show="dnsInputList.length < 6"
                    class="btn-add"
                    @click="addEvent"
                  >
                    +
                  </div>
                </div>
              </div>
            </template>
            <div class="item-row" style="margin-top: 20px;">
              <Checkbox class="bj-color-F85A36" v-model="single"> 点此阅读</Checkbox>
              <span style="color: #F85A36; cursor: pointer" @click="dnsModel"
                >《域见未来数交所DNS服务协议》</span
              >
            </div>
            <div class="bj-rows">
              <Button
                  class="bj-w120 bj-h45 bj-confirm-btn"
                  :loading="formLoading"
                  type="primary"
                  @click="onConfirm"
                  >确认提交</Button>
              </div>
          </div>
        </div>
      </div>

    </template>
    <template v-else-if="state === 0 && !DNSResult">
      <div class="nodata">DNS信息加载失败！</div>
    </template>
    <template v-if="state === 1">
      <div class="data-content">
        <Table
          class="bj-2F3033-table"
          :columns="columns"
          :data="list"
          :loading="tableLoading"
        >
        </Table>
      </div>
    </template>
    <!-- 域见未来数交所DNS服务协议 -->
    <rule-modal
      :show.sync="dnsModelShow"
      :content="dnsRulesContent"
      :title="dnsRulesTitle"
    ></rule-modal>
  </div>
</template>
<script>
import { domainDnsList, domainDnsCreate, domainDnsLogList } from "api/user.js";
import ruleModal from "components/ruleModal.vue";
import dnsRules from "assets/rule/dnsRules";
export default {
  name: "myDNS",
  components: {
    ruleModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      state: 0,
      navList: [
        {
          id: 0,
          active: true,
          value: "/my/template",
          label: "DNS设置",
        },
        {
          id: 1,
          active: false,
          value: "/my/template/add",
          label: "DNS修改记录",
        },
      ],
      list: [],
      tableLoading: false,
      columns: [
        {
          key: "createdTime",
          title: "修改时间",
          align: "center",
        },
        {
          key: "dns",
          title: "原DNS",
          align: "center",
        },
      ],
      loading: false,
      name: '',
      formLoading: false,
      form: {
        dnsType: null,
        domain: "",
        id: "",
        dnsPlatform: 0,
      },
      dnsList0: [],
      dnsList1: [],
      dnsInputList: ["", ""],
      DNSResult: false,
      single: false,
      page: 1,
      limit: 10,
      total: 0,
      // 域名管理系统域名push服务协议
      dnsModelShow: false,
      dnsRulesContent: "",
      dnsRulesTitle: "",
    };
  },
  created(){
    this.did = this.$route.query.id;
    this.name = this.$route.query.name;
    this.req_domainDnsList();
  },
  methods: {
    onNavClick(value) {
      this.state = value.id;
      if (value.id === 1) {
        this.onPageChange(1);
      }
    },
    // 域见未来数交所DNS服务协议
    dnsModel() {
      this.dnsModelShow = true;
      if (!this.dnsRulesContent) {
        this.dnsRulesContent = dnsRules.content;
        this.dnsRulesTitle = dnsRules.title;
      }
    },
    // 获取DNS记录
    async req_domainDnsList() {
      const { code, data } = await domainDnsList({ domainId: this.did });
      if (code === 200 && data) {
        this.form.domain = data.ym;
        this.form.dnsType = data.type;
        this.form.id = data.id;
        this.dnsList0 = data.defaults.filter(
          (item) => item.dnsPlatform === 0
        )[0].values;
        this.dnsList1 = data.defaults.filter(
          (item) => item.dnsPlatform === 2
        )[0].values;
        if (data.type === 0) {
          this.dnsList0 = data.valueSet;
        } else if (data.type === 2) {
          this.dnsList1 = data.valueSet;
        } else if (data.type === 1) {
          for (const i in data.valueSet) {
            if (i < 2) {
              this.dnsInputList[i] = data.valueSet[i];
            } else {
              this.dnsInputList.push(data.valueSet[i]);
            }
          }
        }
        this.DNSResult = true;
      }
    },
    cutEvent() {
      this.dnsInputList.splice(this.dnsInputList.length - 1, 1);
    },
    addEvent() {
      this.dnsInputList.push("");
    },
    onCancel() {
      this.current = 0;
      this.page = 1;
      this.list = [];
      this.visibility = false;
    },
    // 确定
    onConfirm() {
      if (this.form.dnsType === null) {
        this.$Message.warning("请选择DNS类型！");
        return;
      }
      if (!this.single) {
        this.$Message.warning(`请同意并阅读《域见未来数交所DNS服务协议》！`);
        return;
      }
      const params = {
        ids: [this.form.id],
        type: this.form.dnsType,
      };
      if (this.form.dnsType === 1) {
        const DNSList = this.dnsInputList.filter(
          (item) => item != null && item !== ""
        );
        if (DNSList.length <= 0) {
          this.$Message.warning("请至少输入一个DNS！");
          return;
        }
        params.values = DNSList;
      }
      this.$Modal.confirm({
        title: "确认修改",
        content: "<p>确定要修改DNS设置吗？</p>",
        onOk: async () => {
          this.formLoading = true;
          try {
            const res = await domainDnsCreate(params);
            if (res.result) {
              this.$Message.success("修改成功！");
              this.single = false;
            } else {
              this.$Message.warning("域名设置DNS失败!");
            }
            this.formLoading = false;
          } catch (error) {
            console.log(error)
            this.$Message.warning("域名设置DNS失败!");
          }
        },
      });
    },
    // 日志数据
    async req_domainDnsLogList() {
      try {
        let params = {
          id: this.form.id,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data, result } = await domainDnsLogList(params);
        this.tableLoading = false;
        if (code === 200 && result) {
          this.list = data.list;
          this.total = 0;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 分页
    onPageChange(val) {
      this.page = val;
      this.req_domainDnsLogList();
    },
  },
};
</script>

    <style lang="less" scoped>
.link-warp {
  position: relative;
  .link-item {
    display: inline-block;
    height: 60px;
    line-height: 60px;
    margin: 0 30px;
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &:first-child {
      margin-left: 0;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #f85a36;
  }
  .goback {
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
  }
}
.nodata {
  height: 200px;
  line-height: 200px;
  text-align: center;
}
.btn-add {
  width: 32px;
  height: 32px;
  line-height: 26px;
  font-size: 20px;
  font-weight: 700;
  border: 1px solid #dcdee2;
  border-radius: 50%;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
  transition: all 0.3s;
}
.item-row{
  display: flex;
  align-items: center;
  color: #fff;
  margin-bottom: 20px;
    .name{
      color: #fff;
      min-width: 100px;
      text-align: right;
      margin-right: 10px;
    }
}

.data-content{
  margin-top: 40px;
}
</style>
